/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invoice_Status_AwaitingInputs */



/**
* | output |
* | --- |
* | "Awaiting payment" |
*
* @param {Partner_Admin_Invoice_Status_AwaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invoice_status_awaiting = /** @type {((inputs?: Partner_Admin_Invoice_Status_AwaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invoice_Status_AwaitingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlung offen")
	return /** @type {LocalizedString} */ ("Awaiting payment")
});